<template>
    <div class="pm-component float-right mr-2">

        <div class="disablePrivateMessages-btn-box">
            <button class="btn-sm" :class="{'active': showPMBox, 'reddot': newPMMessages}" @click="showPMBox = !showPMBox;showConversation = null;newPMMessages = false">
                <b-icon-chat-square-dots></b-icon-chat-square-dots>
            </button>
        </div>
        <div class="private-messages-box" :class="{ disabled: !showPMBox }">
            <button class="btn btn-dark btn-close" @click="showPMBox=false"><b-icon-x></b-icon-x></button>
            <h4 class="mb-3">{{ this.$parent.text_lang[this.$parent.room.language]["text_pm_title"]}}</h4>
            <p v-if="showConversation === null" class="pm-help">{{ this.$parent.text_lang[this.$parent.room.language]["text_pm_description"]}}</p>
            <ul class="list-unstyled p-0 m-0 conversations-list" v-if="showConversation === null">
                <li class="p-1 border-bottom" v-for="(conversation, index) in private_messages" :key="conversation.id" style="overflow:hidden;" @click="setConversation(index)">
                    <div class="row p-0 m-0">
                        <div class="col-12">
                            <strong :class="'username '">
                                {{ $parent.text_lang[$parent.room.language]["text_pm_title"]}} {{ conversation.user_from.name }} {{ $parent.text_lang[$parent.room.language]["text_pm_with"]}} {{ conversation.user_to.name }}
                            </strong>
                            <ul class="list-unstyled p-2 m-0" v-if="conversation.private_messages[conversation.private_messages.length-1]">
                                <li class="p-1 border rounded">
                                    <span class="message-datetime text-muted mr-2">{{ conversation.private_messages[conversation.private_messages.length-1].created }}</span>
                                    <span class="message-datetime text-muted mr-2">{{ conversation.private_messages[conversation.private_messages.length-1].user.name }}</span>
                                    <div class="message-text">{{ conversation.private_messages[conversation.private_messages.length-1].message }}</div>
                                </li>
<!--                                <li :key="message.id" v-for="(message) in conversation.private_messages" class="p-1 border rounded">-->
<!--                                    <span class="message-datetime text-muted mr-2">{{ message.created }}</span>-->
<!--                                    <span class="message-datetime text-muted mr-2">{{ message.user.name }}</span>-->
<!--                                    <div class="message-text">{{ message.message }}</div>-->
<!--                                </li>-->
                            </ul>
                        </div>
                    </div>
                </li>
            </ul>
            <div v-else class="conversation-box">
                <button class="btn btn-dark btn-close-conversation" @click="closeConversation"><b-icon-arrow-return-left></b-icon-arrow-return-left></button>
                <strong style="">
                    {{ $parent.text_lang[$parent.room.language]["text_pm_conversation"]}} {{ private_messages[showConversation].user_from.name }} {{ $parent.text_lang[$parent.room.language]["text_pm_with"]}} {{ private_messages[showConversation].user_to.name }}
                </strong>
                <div class="conversation-box-list">
                    <ul class="list-unstyled p-2 m-0">
                        <li :class="{'text-right': checkFrom(message.user.id)}" :key="message.id" v-for="(message) in private_messages[showConversation].private_messages" class="p-1 mb-1 border rounded">
                            <span class="message-datetime text-muted mr-2">{{ message.created }}</span>
                            <span class="message-datetime text-muted mr-2">{{ message.user.name }}</span>
                            <div class="message-text">{{ message.message }}</div>
                        </li>
                    </ul>
                </div>
                <div class="input-private-message-box">
                <input
                        @keyup.enter="sendPrivateMessage"
                        v-model="newPrivateMessage"
                        type="text"
                        name="message"
                        id="message"
                        :placeholder="$parent.client_settings.message_placeholder"
                        maxlength="180"
                        class="form-control input-box input-private-message">

                <button class="btn-send-pm" @click="sendPrivateMessage"><b-icon-play></b-icon-play></button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    // @vue/component
    export default {
        // props: ['private_messages'],
        components: {
            // Popper,
        },
        data() {
            return {
                showPMBox: false,
                showConversation: null,
                private_message_to: null,
                newPrivateMessage: '',
                private_messages: [],
                newPMMessages: false
            };
        },
        computed: {
            isVisible() {
                return this.showPMBox;
            },
        },
        mounted() {
            this.getPrivateMessages();
        },
        updated() {
            let conversation_box = this.$el.querySelector(".conversation-box-list");
            if(conversation_box) {
                conversation_box.scrollTop = conversation_box.scrollHeight;
            }
        },
        methods: {
            closeConversation() {
                this.showConversation=null;
                this.private_message_to = null;
            },
            checkFrom(user_id) {
                return user_id === this.$parent.user.id;
            },
            setConversation(index) {
                this.newPrivateMessage = '';
                this.showConversation = index;
                this.private_message_to = this.checkFrom(this.private_messages[index].user_to.id)?this.private_messages[index].user_from:this.private_messages[index].user_to;

                // let conversation_box = this.$el.querySelector(".conversation-box-list");
                // conversation_box.scrollTop = conversation_box.scrollHeight;
            },
            open() {
                this.showPMBox = true;
            },
            close() {
                this.showPMBox = false;
                this.showConversation = null;
            },
            truncate(str, n){
                if (str.length <= n) { return str; }
                const subString = str.substr(0, n-1); // the original check
                return subString.substr(0, subString.lastIndexOf(" ")) + "&hellip;";
            },
            getPrivateMessages() {
                this.$http.get(this.$parent.settings.protocol + this.$parent.settings.server + '/api/pm/', {
                    headers: { Authorization: 'Bearer '+this.$parent.token }
                }).then(response => {
                    this.private_messages = response.data;

                    //this.messages = response.data.messages;
                    //this.room_id = response.data.id;
                    this.$echo.join('privatechat'+this.$parent.user.id)
                        .listen('PrivateMessageSent', () => {
                            console.log('PrivateMessageSent event');
                            this.getPrivateMessages();
                            this.newPMMessages = true;
                        })
                        .listen('UserBanned', () => {
                            console.log('UserBanned event');
                            this.$parent.ext_id = null;
                            this.$parent.banned = true;
                            this.$parent.stopListening();
                        });
                })
            },
            sendPrivateMessage() {
                this.$http.post(this.$parent.settings.protocol + this.$parent.settings.server + '/api/pm/',{message: this.newPrivateMessage, user_id_to: this.private_message_to, user_id_from: this.$parent.user.id}, {
                    headers: { Authorization: 'Bearer '+this.$parent.token }
                }).then(() => {
                    this.getPrivateMessages();
                });

                this.newPrivateMessage = '';
            },
            setConversationFromParent(user_to) {
                this.$http.post(this.$parent.settings.protocol + this.$parent.settings.server + '/api/pm/check',{user_to: user_to}, {
                    headers: { Authorization: 'Bearer '+this.$parent.token }
                }).then(response => {
                    this.showPMBox = true;
                    if(response.data.status === 'new') {
                        this.private_messages.push(response.data.conversation);
                        this.setConversation(this.private_messages.length-1);
                    } else {
                        let pos = this.private_messages.map(function(e) { return e.id; }).indexOf(response.data.conversation.id);
                        this.setConversation(pos);
                    }
                });
            }
        },
    };

</script>

<style>
    .btn-close {
        position: absolute;
        top: 15px;
        right: 15px;
        z-index: 4;
    }
    .btn-close-conversation {
        position: absolute;
        top: 15px;
        right: 65px;
        z-index: 4;
    }
    .private-messages-box.disabled { display: none; }
    .private-messages-box {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        background: #FFF;
        height: 100%;
        width: 100%;
        padding: 15px 15px 80px 15px;
        /*overflow-y: scroll;*/
    }

    .disablePrivateMessages-btn-box button {
        background: var(--buttons-color);
        height: 38px;
        border: 1px solid #6c757d;
        color: var(--buttons-text-color);
        position: relative;
    }
    .disablePrivateMessages-btn-box button.active {
        background: var(--buttons-color-inactive);
        color: var(--buttons-text-color);
    }
    .disablePrivateMessages-btn-box button:focus {
        outline: 0;
    }
    .disablePrivateMessages-btn-box button.reddot:before {
        position: absolute;
        right: -4px;
        top: -4px;
        width: 12px;
        height: 12px;
        background: #da0000;
        border-radius: 50%;
        content: '';
    }

    .conversations-list {
        height: calc(100% - 48px);
        overflow-y: scroll;
    }

    .conversations-list li:hover {
        background: #f3f3f3;
        cursor: pointer;
    }

    .conversation-box {

    }

    .conversation-box-list {
        position: absolute;
        display: block;
        height: calc(100% - 180px);
        overflow-y: scroll;
        width: calc(100% - 20px);
    }
    .conversation-box-list::-webkit-scrollbar-track, .conversations-list::-webkit-scrollbar-track
    {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
        background-color: #F5F5F5;
        border-radius: 10px;
    }

    .conversation-box-list::-webkit-scrollbar, .conversations-list::-webkit-scrollbar
    {
        width: 10px;
        background-color: #F5F5F5;
    }

    .conversation-box-list::-webkit-scrollbar-thumb, .conversations-list::-webkit-scrollbar-thumb
    {
        border-radius: 10px;
        background-color: #FFF;
        background-image: -webkit-gradient(linear,
        40% 0%,
        75% 84%,
        from(#4D9C41),
        to(#19911D),
        color-stop(.6,#54DE5D))
    }

    .input-private-message-box {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 20px;
        background: #FFF;
    }

    .input-private-message {
        padding-right: 40px !important;
    }

    .btn-send-pm {
        position: absolute;
        top: 21px;
        right: 1.6rem;
        width: 32px;
        height: 36px;
        padding: 0;
        background: none;
        border: 0;
        transition: all 0.2s;
    }
    .btn-send-pm svg {
        color: #b1c6d0;
        font-size: 32px;
    }

    @media (max-width: 478px) {
        .conversations-list {
            height: calc(100% - 96px);
            overflow-y: scroll;
        }
    }
</style>
